import React from 'react';
import {Link} from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import logo from '../images/logo.jpg'; // Update with correct path

const Footer = () => {
    return (
      <>
        <footer>
          <div className="footer max-w-full mx-auto px-4 sm:px-6 bg-gray-100 border-t border-b py-30">
            {/* Top area: Blocks */}
            <div className="grid sm:grid-cols-12 gap-5 py-8 md:py-12 border-t border-gray-200 lg:ml-11">
              {/* 1st block */}
              <div className="col-span-12 lg:col-span-4">
                <div
                  className="flex items-center justify-center box-border border-t-4 border-blue-900 p-8 text-gray-700 text-center rounded-full shadow-xl transition-all transform hover:scale-105 xl:w-60 h-30 mx-auto sm:p-4"
                  style={{
                    backgroundColor: "#f8f6f6",
                    maxWidth: "250px",
                    width: "100%",
                  }}
                >
                  <img
                    src={logo}
                    alt="Description of Image"
                    className="w-20 h-16 sm:w-16 sm:h-12 md:w-20 md:h-16 lg:w-25 lg:h-20 object-cover"
                    style={{ maxWidth: "100%", height: "auto" }}
                  />
                </div>
              </div>

              {/* 2nd block */}
              <div className="col-span-6 md:col-span-6 lg:col-span-1 ml-7 mx-auto">
                <h6 className="text-[#013289] text-xl font-bold mb-4">LINKS</h6>
                <ul className="text-md">
                  <li className="mb-2">
                    <HashLink
                      to="/#about"
                      className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                    >
                      About
                    </HashLink>
                  </li>
                  <li className="mb-2">
                    <HashLink
                      to="/#services"
                      className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                    >
                      Services
                    </HashLink>
                  </li>
                  <li className="mb-2">
                    <HashLink
                      to="/contact"
                      className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out"
                    >
                      Contact
                    </HashLink>
                  </li>
                </ul>
              </div>

              {/* 3rd block */}
              <div className="col-span-6 md:col-span-6 lg:col-span-4 mx-auto">
                <h6 className="text-[#013289] text-xl font-bold mb-4">
                  OUR SERVICES
                </h6>
                <ul className="text-md">
                  <li className="mb-2">
                    {/* <Link to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Research & Development
                            </Link> */}
                    <div className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">
                      Research & Development
                    </div>
                  </li>
                  <li className="mb-2">
                    {/* <Link to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Provide Custom Solutions</Link> */}
                    <div className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">
                      Provide Custom Solutions
                    </div>
                  </li>
                  <li className="mb-2">
                    {/* <Link to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Devices & Software Production</Link> */}
                    <div className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out">
                      Devices & Software Production
                    </div>
                  </li>
                  <li className="mb-2">
                    {/* <Link to="#" className="text-[#013289] hover:text-gray-900 hover:tracking-wider transition duration-250 ease-in-out">Deployment, Integration & Training</Link> */}
                    <div
                      to="#"
                      className="text-[#013289] hover:text-gray-900 transition duration-250 ease-in-out"
                    >
                      Deployment, Integration & Training
                    </div>
                  </li>
                </ul>
              </div>

              {/* 4th block */}
              <div className="col-span-12 text-center mx-auto lg:col-span-3 font-bold uppercase text-blue-900">
                <div className="text-xl mb-6">Social Media Links.</div>

                <div className="text-md font-medium mb-6">
                  Follow us on social media.
                </div>
                <div className="mx-auto text-center mt-2">
                  <ul className="flex justify-center mb-4 md:mb-0">
                    <li>
                      <Link
                        to="#"
                        className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
                        aria-label="Twitter"
                      >
                        <svg
                          className="w-8 h-8 fill-current"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M24 11.5c-.6.3-1.2.4-1.9.5.7-.4 1.2-1 1.4-1.8-.6.4-1.3.6-2.1.8-.6-.6-1.5-1-2.4-1-1.7 0-3.2 1.5-3.2 3.3 0 .3 0 .5.1.7-2.7-.1-5.2-1.4-6.8-3.4-.3.5-.4 1-.4 1.7 0 1.1.6 2.1 1.5 2.7-.5 0-1-.2-1.5-.4 0 1.6 1.1 2.9 2.6 3.2-.3.1-.6.1-.9.1-.2 0-.4 0-.6-.1.4 1.3 1.6 2.3 3.1 2.3-1.1.9-2.5 1.4-4.1 1.4H8c1.5.9 3.2 1.5 5 1.5 6 0 9.3-5 9.3-9.3v-.4c.7-.5 1.3-1.1 1.7-1.8z" />
                        </svg>
                      </Link>
                    </li>
                    <li className="ml-4">
                      <Link
                        to="#"
                        className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
                        aria-label="Facebook"
                      >
                        <svg
                          className="w-8 h-8 fill-current"
                          viewBox="0 0 32 32"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path d="M14.023 24L14 17h-3v-3h3v-2c0-2.7 1.672-4 4.08-4 1.153 0 2.144.086 2.433.124v2.821h-1.67c-1.31 0-1.563.623-1.563 1.536V14H21l-1 3h-2.72v7h-3.257z" />
                        </svg>
                      </Link>
                    </li>
                    <li className="ml-4">
                      <Link
                        to="https://www.linkedin.com/company/attune-integrations/"
                        className="flex justify-center items-center text-blue-900 hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-150 ease-in-out"
                        aria-label="LinkedIn"
                      >
                        <svg
                          className="w-8 h-8 fill-current"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                        >
                          <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.761 0 5-2.239 5-5v-14c0-2.761-2.239-5-5-5zm-11.25 19.417h-2.75v-8.5h2.75v8.5zm-1.375-9.681c-.883 0-1.583-.711-1.583-1.583s.711-1.583 1.583-1.583c.871 0 1.583.711 1.583 1.583s-.711 1.583-1.583 1.583zm11.625 9.681h-2.75v-4.25c0-1.011-.036-2.311-1.411-2.311-1.411 0-1.625 1.103-1.625 2.236v4.325h-2.75v-8.5h2.625v1.161h.036c.364-.682 1.25-1.403 2.571-1.403 2.746 0 3.25 1.808 3.25 4.156v4.586z" />
                        </svg>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap items-center md:justify-between justify-center mx-auto px-4">
              <div className="w-full md:w-4/12 px-4 mx-auto text-center py-2">
                <div className="text-sm text-gray-200 font-semibold py-1">
                  Copyright &copy; {new Date().getFullYear()}
                  {"  "}
                  <HashLink to="#" className=" hover:text-gray-900">
                    attune integrations
                  </HashLink>
                  . All rights reserved.
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
}
export default Footer;
